<template>
  <div style="padding: 10px 14px; direction: rtl; text-align: right;">
    <h3>اتفاقية الخصوصية للمستخدم</h3>
    <p>
      <strong>
        يرجى قراءة هذا الدليل بعناية وضمان فهمك لقواعدنا في معالجة معلوماتك الشخصية. إذا كان لديك أي أسئلة أثناء قراءة هذا الدليل، يرجى الاتصل بنا. إذا فهمت ووافقت على قبول هذا الدليل، يمكنك النقر على "موافق" لبدء استخدام خدماتنا. إذا كنت لا توافق على أي بند من بنود هذا الدليل، يرجى التوقف على الفور عن الوصول إليه واستخدامه.
      </strong>
    </p>
    <strong><p>1. نطاق تطبيق اتفاقية الخصوصية</p></strong>
    <p>（1）المعلومات الشخصية المتعلقة بالهوية التي تتركها عند استخدام خادم التطبيق؛</p>
    <p>（2）المعلومات المختلفة التي تنتقل بينك وبين الآخرين من خلال خادم التطبيق؛</p>
    <p>（3）أي معلومات أخرى مشتركة بين التطبيق والشركاء التجاريين، سواء كانت تخصك أو لا تخصك؛</p>
    <p>
      （4）يلتقط برنامج {{ activationCompany.abbreviation }} أهمية كبيرة لحماية خصوصيتك الشخصية، وقد صاغ اتفاقية الخصوصية للمستخدم. يمكنك أيضًا استخدام اتفاقية الخصوصية للمستخدم. أنت تؤكد وتوافق على أن استخدام الخدمات التي يوفرها برنامج {{ activationCompany.abbreviation }} سيتم اعتباره قبولًا لاتفاقية الخصوصية للمستخدم.
    </p>
    <strong><p>2. وصف جمع واستخدام معلومات المستخدم</p></strong>
    <strong>
      <p>
        <u>
          2.1 عند التسجيل والدخول، سنجمع معلوماتك الشخصية، بما في ذلك ولكن ليس محدودًا إلى الاسم المستعار، الصورة الشخصية، رقم الهاتف، واتساب، قوقل كو، إلخ، للمساعدة في إكمال التسجيل والدخول واستخدام خدمات البرنامج، وحماية أمان حسابك؛ سنجمع واستخدم أرقام الهواتف التي تقوم بتحميلها بنفسك للاتصلات اللاحقة وإشعارات الفعاليات.
        </u>
      </p>
    </strong>
    <strong>
      <u>
        <p>
          2.2 بعد اكتمال التسجيل، يمكنك الاختيار تقديم المعلومات الشخصية التالية: نوع مدرستك، المرحلة التعليمية (مثل المدرسة الابتدائية، المدرسة المتوسطة، المدرسة الثانوية)، ومعلومات المواد (مثل اللغة الصينية، الرياضيات، الإنجليزية). لتعزيز التميز، سيتم عرض الأسماء المستعارة ومعلومات المواد المرتبطة بالمرحلة التعليمية بشكل علني (على سبيل المثال، بعد تحميل أو تنزيل عرض تقديمي من المكتبة، سيظهر في المكتبة). إذا كنت لا تقدم هذه المعلومات، فلن يؤثر ذلك على استخدامك للوظائف الأساسية للبرنامج.
        </p>
      </u>
    </strong>
    <strong>
      <u>
        <p>
          2.3 قد تتطلب بعض خدماتنا منك تقديم معلومات حساسة شخصية معينة لتحقيق وظائف معينة. إذا اخترت عدم تقديم مثل هذه المعلومات، فقد لا تتمكن من استخدام بعض ميزات الخدمة بشكل طبيعي، ولكن هذا لن يؤثر على قدرتك على استخدام الوظائف الأساسية للخدمة. من خلال تقديم معلوماتك الشخصية الحساسة تلقائياً، توافق على أننا يمكننا معالجتها للأغراض والاستخدامات المحددة في هذه الاتفاقية أو التنبيهات الأخرى.
        </p>
      </u>
    </strong>
    <p>
      2.4 يرجى فهم أن الوظائف والخدمات التي نقدمها لك تتم تحديثها وتطويرها باستمرار. إذا كانت وظيفة أو خدمة معينة لا تجمع معلوماتك كما ذكر أعلاه ولكنها تحتاج إلى جمع معلوماتك، سنتوضح محتوى نطاق وأغراض جمع المعلومات لك من خلال تحديث هذه الاتفاقية، أوجه إشارة الصفحة، عمليات التفاعل، إشعارات غير מקוונת وغيرها، وستحصل على موافقتك.
    </p>
    <p>
      2.5 يرجى فهم أن الوظائف والخدمات التي نقدمها لك تتم تحديثها وتطويرها باستمرار. إذا كانت وظيفة أو خدمة معينة لا تجمع معلوماتك كما ذكر أعلاه ولكنها تحتاج إلى جمع معلوماتك، سنتوضح محتوى نطاق وأغراض جمع المعلومات لك من خلال تحديث هذه الاتفاقية، أوجه إشارة الصفحة، عمليات التفاعل، إشعارات غير מקוונת وغيرها، وستحصل على موافقتك.
    </p>
    <strong><p>3. شرح الكشف عن معلومات المستخدم</p></strong>
    <p>
      3.1 احترام الخصوصية الشخصية للمستخدمين هو سياسة أساسية لـ {{ activationCompany.abbreviation }}. لذلك، لن ي divulg أو يحرر أو يكشف {{ activationCompany.abbreviation }} عن معلومات التسجيل للمستخدمين والمحتويات غير العامة المخزنة في هذا التطبيق بدون تفويض المستخدم القانوني، إلا في الحالات التالية:
    </p>
    <p>（1）القوانين ذات الصلة أو الشروط اللازمة لـ {{ activationCompany.abbreviation }} لتنفيذ واجباته القانونية أو التزاماته؛</p>
    <p>（2）أولئك المتعلقة بشكل مباشر بالأمان القومي، والأمان الدفاعي القومي، الأمان العام، الصحة العامة والمصالح العامة الرئيسية；</p>
    <p>（3）أولئك المتعلقة بشكل مباشر بالتحقيقات الجنائية، والإقامة، المحاكمة وتنفيذ الحكم；</p>
    <p>（4）للحماية حقوق العلامات التجارية لـ {{ activationCompany.abbreviation }}، حقوق الاختراع وأي حقوق أخرى مشروعة；</p>
    <p>
      （5）رداً على حالة صحية عامة، أو في حالة طارئة لحماية حياة أو ممتلكاتك أو حقوقك المشروعة الأخرى الرئيسية للأفراد الآخرين；
    </p>
    <p>
      （6）معالجة معلوماتك الشخصية التي كنت قد كشفت عنها أو التي تم الكشف عنها قانونيًا ضمن نطاق معقول وفقاً لقانون حماية المعلومات الشخصية لجمهورية الصين الشعبية، إلا عندما ترفض صراحةً. عندما يكون للمعلومات التي تم جمعها تأثير كبير على حقوقك الشخصية المصالح، سنتأخذ موافقتك وفقاً للقانون；
    </p>
    <p>（7）جمع المعلومات الشخصية من المعلومات التي تم الكشف عنها قانونيًا، مثل التقارير الإخبارية القانونية ووسائل الكشف عن المعلومات الحكومية；</p>
    <p>（8）للحفاظ على التشغيل الآمن والثابت للمنتجات أو الخدمات المقدمة، مثل اكتشاف ومعالجة العيوب في المنتجات أو الخدمات；</p>
    <p>（9）حالات أخرى تتطلب الكشف عن المعلومات الشخصية أو تحريرها أو الكشف عنها.</p>
    <strong><p>4. تخزين المعلومات</p></strong>
    <p>
      <strong>
        <u>
          4.1 سنتستخدم تدابير أمان مختلفة بمستوى معقول لحماية معلوماتك الشخصية. ومع ذلك، يرجى فهم أن نظرًا للقيود التكنولوجية والتطور السريع في صناعة الإنترنت، بالإضافة إلى الاعتداءات الخبيثة المحتملة، حتى لو بذل {{ activationCompany.abbreviation }} قصارى جهداته لتحسين تدابير الأمان، لا يمكنه ضمان أمان 100% للمعلومات. لذلك، لا يمكننا ضمان أمان أو سلامة أي معلومات شخصية تم إرسالها عبر الإنترنت.
        </u>
      </strong>
    </p>
    <p>
      4.2 موقع التخزين: سنتخزن المعلومات الشخصية التي تم جمعها على خوادم في الصين وفقاً للمطالبات الخاصة بالقوانين واللوائح الصينية المطبقة. بدون موافقتك، لن ننقل معلوماتك الشخصية إلى الخارج.
    </p>
    <p>
      4.3 بشكل عام، نحن فقط نخزن معلوماتك لفترة زمنية صغيرة nhất محددة بالقانون وسنحذف معلوماتك بعد انتهاء التاريخ. ومع ذلك، في الحالات التالية، قد نغير وقت تخزين المعلومات الشخصية لتحسين الامتثال للمطالبات القانونية:
    </p>
    <p>（1）للامتثال للقوانين واللوائح المعمول بها；</p>
    <p>（2）للامتثال لأحكام المحكمة، أو الأحكام أو الإجراءات القانونية الأخرى；</p>
    <p>（3）للامتثال للمطالبات من الجهات الحكومية ذات الصلة أو المنظمات المصرح بها قانونيًا；</p>
    <p>（4）لدينا أسباب لنعتقد أننا بحاجة إلى الامتثال للقوانين واللوائح ذات الصلة；</p>
    <p>
      （5）لغرض تنفيذ اتفاقيات الخدمات ذات الصلة أو هذا الدليل، والحفاظ على المصالح العامة، وحماية الأمان الشخصي والممتلكات أو حقوق أخرى مشروعة لعملائنا، لدينا أو الشركات التابعة، المستخدمين الآخرين أو الموظفين.
    </p>
    <p>
      4.4 سنتخزن معلوماتك الشخصية وفقاً للقوانين واللوائح، وسيتم تخزين معلومات المستخدم الشخصية التي تم جمعها في الصين في الصين. حالياً، لن ننقل أو نخزن معلوماتك الشخصية عبر الحدود. في المستقبل، إذا كنا بحاجة إلى نقل أو تخزين معلوماتك الشخصية عبر الحدود، سنجعل ذلك وفقاً للقوانين واللوائح ذات الصلة.
    </p>
    <strong><p>5. الكشف عن المعلومات ومشاركتها</p></strong>
    <p>
      5.1 {{ activationCompany.abbreviation }} لن يكشف عمدًا أو يأجر أو يبيع معلوماتك الشخصية والمعلومات لأي طرف ثالث. ومع ذلك، تستثني الحالات التالية:
    </p>
    <p>（1）أنت توافق على مشاركة المعلومات والمعلومات مع أطراف ثالثة；</p>
    <p>（2）فقط من خلال الكشف عن معلوماتك الشخصية والمعلومات يمكننا تقديم لك بعض المنتجات والخدمات كما المطلوب；</p>
    <p>
      （3）يجب تقديمهاตาม طلب الجهة التي تمثل هذا التطبيق لتقديم المنتجات أو الخدمات (إلا إذا أبلغنا بخلاف ذلك، فإن هذه الجهات ليس لديها الحق في استخدام معلوماتك الشخصية والبيانات لأغراض أخرى غير تقديم المنتجات والخدمات): كما المطلوب بواسطة القوانين، واللوائح، أو الأوامر الإدارية； بسبب الاحتياجات للتدقيق الخارجي； إذا كنت تنتهك شروط استخدام هذا التطبيق أو أي منتج أو خدمة أخرى； إذا، بعد تقييمنا، كان حسابك يُنظر إليه على أن لديه مخاطر وتحتاج إلى الحماية.
    </p>
    <p>
      5.2 عندما تستخدم خدماتنا، توافق على أن معلوماتك الشخصية يمكن أن تُكشف لمعلمين آخرين في الفصل والطلاب في الفصل. بالإضافة إلى ذلك، لن نشارك معلوماتك الشخصية مع أي شركات أو منظمات أو أفراد ثالثين، إلا في الحالات التالية:
    </p>
    <p>（1）المشاركة مع موافقتك الصريحة: سندرس معلوماتك الشخصية مع أطراف أخرى بعد الحصول على موافقتك الصريحة.</p>
    <p>
      （2）قد نشارك معلوماتك الشخصية مع أطراف أخرى وفقاً للقوانين واللوائح أو المطالبات الإلزامية من الجهات الحكومية المختصة.
    </p>
    <p>
      （3）المشاركة مع الشركات التابعة لنا: قد تُشارك معلوماتك الشخصية مع الشركات التابعة لـ {{ activationCompany.abbreviation }}. سندرس فقط المعلومات الشخصية اللازمة وستخضع لأغراض محددة في سياسة الخصوصية هذه. إذا أرادت شركة تابعة تغيير الغرض من معالجة المعلومات الشخصية، ستحاول مرة أخرى الحصول على تفويضك وموافقتك.
    </p>
    <p>（4）مشاركة مع المنتجات تحت علامة {{ activationCompany.abbreviation }}.</p>
    <strong><p>6. حقوقك في معلوماتك الشخصية</p></strong>
    <p>
      6.1 أثناء استخدامك لمنتجاتنا والخدمات، لجعل من السهل لك الوصول إلى إدارة المعلومات، ولضمان حقك في إغلاق الحساب، لقد وفرنا إعدادات عمليات مقابلة في العميل. يمكنك اتباع التعليمات الموجودة فيها لإجراء الإجراءات اللازمة. بالإضافة إلى ذلك، يمكنك الاتصل بنا من خلال هذه السياسة لطلب الوصول إلى معلوماتك الشخصية أو تصحيحها أو حذفها.
    </p>
    <p>6.2 في الحالات التالية، يمكنك الاتصل بفريق الدعم لدينا لطلب حذف المعلومات الشخصية المقابلة:</p>
    <p>（1）نحن نجمع أو نخزن أو نستخدم أو نقدم المعلومات الشخصية للعموم بطريقة تنتهك القوانين أو اللوائح الإدارية أو الاتفاق بين الأطراف；</p>
    <p>（2）جمع أو تخزين أو استخدام أو تقديم المعلومات الشخصية خارج نطاق الغرض أو الحد الزمني اللازم；</p>
    <p>（3）تتراجع عن موافقتك；</p>
    <p>（4）تنهي استخدام جميع منتجاتنا أو خدماتنا عن طريق الإلغاء.</p>
    <p>6.3 الرد على طلبك كما يلي</p>
    <p>
      لضمان الأمان، قد يُطلب منك تقديم طلب مكتوب أو إثبات هويتك بطريقة أخرى. قد نطلب منك التحقق من هويتك قبل معالجة طلبك.
    </p>
    <strong><p>7. الرعاية للقاصرين</p></strong>
    <p>
      <strong>
        <u>
          نقدر حماية معلومات القاصرين الشخصية. نظرًا لطبيعة هذا البرنامج، نحن لا نقدمه أو خدماته للقاصرين. أثناء استخدامك لخدماتنا، نفترض أن لديك القدرة المقابلة للتأديف المدني. إذا كنت قاصرًا، قبل استخدام أي خدمات مرتبطة بهذا البرنامج، يجب عليك قراءة سياسة الخصوصية هذه بعناية تحت إشراف وتوجيه والدي أو الأوصياء الآخرين، وتقديم معلوماتك لنا فقط بعد الحصول على موافقتهم.
        </u>
      </strong>
    </p>
    <strong><p>8. التغييرات</p></strong>
    <p>
      <strong>
        <u>
          قد نقوم بمراجعة هذا الدليل في أوقات مناسبة. عندما تتغير بنود هذا الدليل، سنتصل بك بمعلومات عن دليل حماية الخصوصية المحدث بطريقة مناسبة عند تحديث الإصدار، وندعوك إلى التاريخ الفعال. يرجى قراءة دليل حماية الخصوصية المعدل بعناية. تحتاج إلى موافق على معالجة معلوماتك الشخصية وفقاً لدليل حماية الخصوصية المحدث عن طريق النقر أو التأشير في المربعات المناسبة مرة أخرى.
        </u>
      </strong>
    </p>
    <strong><p>9. كيفية الاتصل بنا</p></strong>
    <p>
      إذا كان لديك أي أسئلة أو تعليقات أو اقتراحات حول سياسة الخصوصية هذه، يرجى الاتصل بنا من خلال الطرق التالية، وسنرد عليك في الوقت المناسب وفقاً للمطالبات الخاصة بالقوانين واللوائح المعمول بها:
    </p>
    <p>الشركة: {{ activationCompany.company }}</p>
    <p>التليفون: 400-632-8880</p>
    <p>الشخص المتصل: متخصص خدمة العملاء</p>
    <p>العنوان: {{ activationCompany.address }}</p>
    <p>
      <strong>
        <u>
          سنتقوم بمراجعة المشكلات المتعلقة في أقرب وقت ممكن وسنرد بسرعة بعد التحقق من هوية المستخدم. في معظم الحالات، سندرد على طلبك خلال 15 يوماً عمل. إذا لم نتمكن من الرد على طلبك، سنتصل بك ونشرح الأسباب خلال الوقت القانوني. إذا كنت غير راضٍ عن ردنا، وخاصةً إذا كان معالجة المعلومات الشخصية لدينا قد انتهكت حقوقك المشروعة، يمكنك البحث عن حلول من خلال القنوات الخارجية التالية: تقديم دعوى إلى المحكمة المحلية حيث تم تسجيل شركة دونغ Guan {{ activationCompany.abbreviation }} لتصنيع المواد الضوئية الإلكترونية المحدودة.
        </u>
      </strong>
    </p>
  </div>
</template>
<script>
import utils from '@/utils/index'
import config from '@/config/index'
export default {
  data() {
    return {
      activationCompany: {
        company: 'Dongguan Andao Optoelectronic Materials Manufacturing Co., LTD',
        address: 'Building A, Building 11, Zone C, Songshan Lake International Finance Park, Dongguan City, Guangdong Province',
        abbreviation: 'Andao'
      }
    }
  },
  created() {
    // this.activationCompany = config.companyList[0]
  },
  mounted() {
    const identify = utils.getParamByUrl('cType')
    if (identify) {
      this.activationCompany = config.companyList[identify]
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
h3 {
  font-size: 16px;
  text-align: center; /* العنوان يبقى محاذيًا بالمنتصف حتى في RTL */
  margin: 15px 0;
}

p {
  font-size: 14px;
  margin: 8px 0;
  direction: rtl; /* تحديد اتجاه النص من اليمين إلى اليسار */
  text-align: right; /* محاذاة النص إلى اليمين */
  line-height: 1.6; /* تحسين قابلية القراءة */
}

/* تحسين عرض الأرقام والفقرات المُرقمة */
p:has(> strong), strong > p {
  margin-top: 12px;
  margin-bottom: 8px;
}

u {
  text-underline-offset: 3px; /* ضبط مسافة التسطير عن النص */
}
</style>
